// extracted by css-extract-rspack-plugin
export default {"link":"ExternalLink_link__s-U1b"};